import { useContext } from 'react';
import { AuthenticationContext, AuthenticationContextValue } from '../context/AuthenticationContext';
export function useAuth() {
  return useContext(AuthenticationContext);
}